((ns) => {
  const { logError, createSearchInstance, initWithRetry } = ns;

  const initializeSearch = async () => {
    const dataElem = document.querySelector("#collection-products-section-data");
    const collectionId = dataElem ? JSON.parse(dataElem.textContent).collection_id : null;

    const config = {
      filters: collectionId ? `collection_ids:${collectionId}` : "",
    };

    return createSearchInstance(config);
  };

  // Automatisch starten, wenn DOM bereit ist
   

  document.addEventListener("DOMContentLoaded", () => {
     // Initialize filter button/drawer interactions (mobile & desktop)
     try {
      if (typeof ns.initializeFilterButtons === "function") {
        ns.initializeFilterButtons();
      }
    } catch (e) {
      // no-op: initialization of filter buttons is non-critical
    }
    initWithRetry(initializeSearch).catch((error) => {
      logError(error, "Final initialization failure");
    });
  });
})((window.ProductSearch = window.ProductSearch || {}));